module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "size": "small"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Erreur Coûteuse !!!\n            "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("\n                Et oui t'as plus de 100 kpO en trésor, donc paf, erreur coûteuse. \n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-6 columns"
  }, [_c('div', {
    staticClass: "row columns note"
  }, [_vm._v("\n                    Jet d'erreur coûteuse :\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_c('br'), _vm._v(" "), _c('img', {
    staticClass: "large-7 large-centered team-icon-big",
    attrs: {
      "src": _vm.getDiceIcon(),
      "alt": ""
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "large-6 columns"
  }, [_c('div', {
    staticClass: "row columns note"
  }, [_vm._v("\n                    Résultat :\n                    ")]), _vm._v(" "), (this.spiralingExpenseResult.lost_treasury !== 0) ? _c('div', {
    staticClass: "row columns"
  }, [_c('br'), _vm._v("\n                        tu perds " + _vm._s(this.spiralingExpenseResult.lost_treasury) + " 000 pO \n                    ")]) : _vm._e(), _vm._v(" "), (this.spiralingExpenseResult.lost_treasury === 0) ? _c('div', {
    staticClass: "row columns"
  }, [_vm._v("\n                        tu perds rien \n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row columns"
  }, [_vm._v("\n                        " + _vm._s(_vm.getMessage()) + "\n                    ")]), _vm._v(" "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.$emit('closeMessage')
      }
    }
  }, [_vm._v("Ok")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36355961"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/spiraling-expense-modal.vue
// module id = 732
// module chunks = 0